export const InfoLineKeys = {
  DURATION_IN_MONTHS: 'DURATION_IN_MONTHS',
  CREDIT_AMOUNT: 'CREDIT_AMOUNT',
  INTEREST: 'INTEREST',
  MONTHLY_ADMIN_FEE: 'MONTHLY_ADMIN_FEE',
  ACCOUNT_FEE: 'ACCOUNT_FEE',
  NORMAL_MONTHLY_REPAYMENT_AMOUNT: 'NORMAL_MONTHLY_REPAYMENT_AMOUNT',
  EFFECTIVE_INTEREST: 'EFFECTIVE_INTEREST',
  ARRANGEMENT_FEE: 'ARRANGEMENT_FEE',
  CREDIT_COST: 'CREDIT_COST',
  TOTAL_LOAN_COST: 'TOTAL_LOAN_COST',
  INVOICE_FEE: 'INVOICE_FEE',

  DUE_DATE: 'DUE_DATE',
  PAYMENT_PERIOD: 'PAYMENT_PERIOD',
  TOTAL_COST: 'TOTAL_COST',
}

export const InfoLineType = {
  CURRENCY: 'CURRENCY',
  PERCENTAGE: 'PERCENTAGE',
  MONTH: 'MONTH',
  DATE: 'DATE',
  DAY: 'DAY',
}

export const InfoLineProperties = {
  [InfoLineKeys.DURATION_IN_MONTHS]: {
    label: 'priceInfo.infoLine.durationInMonths',
    type: InfoLineType.MONTH,
  },
  [InfoLineKeys.CREDIT_AMOUNT]: {
    label: 'priceInfo.infoLine.creditAmount',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.INTEREST]: {
    label: 'priceInfo.infoLine.interest',
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.MONTHLY_ADMIN_FEE]: {
    label: 'priceInfo.infoLine.monthlyAdminFee',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.ACCOUNT_FEE]: {
    label: 'priceInfo.infoLine.accountFee',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.NORMAL_MONTHLY_REPAYMENT_AMOUNT]: {
    label: 'priceInfo.infoLine.normalMonthlyRepaymentAmount',
    type: InfoLineType.CURRENCY,
    reservations: 1,
  },
  [InfoLineKeys.EFFECTIVE_INTEREST]: {
    label: 'priceInfo.infoLine.effectiveInterest',
    type: InfoLineType.PERCENTAGE,
  },
  [InfoLineKeys.ARRANGEMENT_FEE]: {
    label: 'priceInfo.infoLine.arrangementFee',
    type: InfoLineType.CURRENCY,
    reservations: 2,
  },
  [InfoLineKeys.CREDIT_COST]: {
    label: 'priceInfo.infoLine.creditCost',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.TOTAL_LOAN_COST]: {
    label: 'priceInfo.infoLine.totalLoanCost',
    type: InfoLineType.CURRENCY,
  },
  [InfoLineKeys.INVOICE_FEE]: {
    label: 'priceInfo.infoLine.invoiceFee',
    type: InfoLineType.CURRENCY,
  },

  [InfoLineKeys.DUE_DATE]: {
    label: 'priceInfo.infoLine.dueDate',
    type: InfoLineType.DATE,
  },
  [InfoLineKeys.PAYMENT_PERIOD]: {
    label: 'priceInfo.infoLine.paymentPeriod',
    type: InfoLineType.DAY,
  },
  [InfoLineKeys.TOTAL_COST]: {
    label: 'priceInfo.infoLine.totalCost',
    type: InfoLineType.CURRENCY,
  },
}
